export default {
    SMS_TEMPLATES(state, value) {
        state.smsTemplates = value;
    },
    EMAIL_TEMPLATES(state, value) {
        state.emailTemplates = value;
    },
}